import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/comics";

export default function CategoryShortcuts() {
  return (
    <section aria-labelledby="category-shortcuts" className="w-full px-4 md:px-6">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <h2 id="category-shortcuts" className="font-heading text-xl md:text-2xl font-semibold text-foreground-50">
            分类快捷入口
          </h2>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-400">按题材进入对应漫画分类列表，筛选条件可在分类页自由组合。</p>
        </div>
        <Link
          to="/category/hot-blood"
          className="hidden sm:flex items-center gap-1 text-xs text-foreground-400 hover:text-accent-300 transition-colors whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {CATEGORIES.map((cat, i) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group card-lift rounded-lg border hairline bg-background-900/60 p-4 md:p-5 flex flex-col gap-3 animate-fade-up"
            style={{ animationDelay: `${i * 45}ms` }}
          >
            <span className="w-10 h-10 rounded-md flex items-center justify-center bg-primary-800/70 text-accent-300 group-hover:bg-accent-500 group-hover:text-background-950 transition-colors">
              <i className={`${cat.icon} text-lg`} />
            </span>
            <span className="flex items-center gap-2">
              <span className="text-sm md:text-[15px] font-medium text-foreground-50">{cat.name}</span>
              <span className="text-[10px] font-label tracking-[0.14em] text-foreground-500 uppercase">{cat.en}</span>
            </span>
            <span className="text-[11px] md:text-xs leading-5 text-foreground-400 line-clamp-2">{cat.desc}</span>
            <span className="mt-auto flex items-center gap-1 text-[11px] text-accent-400 opacity-0 group-hover:opacity-100 transition-opacity">
              进入分类 <i className="ri-arrow-right-s-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}